export class Token {
  public expiry: string | undefined | null;
  public cvv: string | undefined | null;
  public message: string | undefined | null;
  public validationError: string | undefined | null;
  public valid: boolean | undefined | null;
  public brand: string | undefined | null;
}
